/*
 * File: d:\projects\AutoFiFront\src\Content\Login\Form\Form.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday January 13th 2023 2:10:45 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useState } from "react";
import styles from "Content/Login/Form/Form.module.css";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import UserService from "Services/Users/UserService";
import { useNavigate } from "react-router-dom";
import Input from "Theme/Component/Input";
import InputSubmit from "Theme/Component/InputSubmit";
import Alert from "react-bootstrap/Alert";
import translator from "MultiLanguage/TranslationWrapper";
import Link from "Theme/Component/Link";
import ServiceGeneral from 'Services/ServiceGeneral';

type FormLoginPropsType = {
    returnUrl?: string | null
};

/**
 * Hook for the Form component of the login component
 * @param {Object} props The props passed to the component
 */
function Form(props: FormLoginPropsType) {
    const [ username, setName ] = useState("");
    const [ password, setPassword ] = useState("");
    const [ loginError, setLoginError ] = useState(false);
    const navigate = useNavigate();
    const return_url = props.returnUrl;

    /**
     * Handle submission of the form
     * @param {*} event The event object triggered when form submitted
     */
    const HandleSubmit =  async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const response = await UserService.login(username, password);
        ServiceGeneral.handleAxiosResponse(response);

        if (response.status !== 200 && response.status !== 304)
            setLoginError(response.data.message);
        else if (return_url !== undefined && return_url !== null)
            navigate(return_url);
        else
            navigate(RouterPathResolver.routeSynchroCar.path);
    };

    return (
        <div id={styles.div_form} className={"padded medium-round-border"}>
            <form className={"margined block"} onSubmit={HandleSubmit}>
                {loginError &&
                    <Alert variant="danger" className="margined block">
                        {translator.decode("login.error_message")}
                    </Alert>
                }
                <Input
                id="username"
                type="text"
                className={"block h-center-div full-width " + styles.input}
                variant="none"
                value={username}
                placeholder={translator.decode("login.placeholder.username")}
                onChange={(e: React.FormEvent<HTMLInputElement>) => {setName(e.currentTarget.value)}}
                />
                <Input
                id="password"
                className={"block h-center-div full-width margin-bottom " + styles.input}
                type="password"
                variant="none"
                value={password}
                placeholder={translator.decode("login.placeholder.password")}
                onChange={(e: React.FormEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)}
                />
                <InputSubmit
                className={"block h-center-div full-width font-weight-700 large-font-2 margin-bottom " + styles.input_submit}
                value={translator.decode("login.send")}/>
            </form>
        </div>
    );
}

export default Form;
